<form [formGroup]="form">

    <div class="mt-3" formGroupName="featureSettings">

        <mat-accordion [formGroupName]="item">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="font-bold">
                        {{title}}

                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status [hasError]="errorsString.includes(item)"></sway-baseline-status>
                    </div>
                </mat-expansion-panel-header>

                <div>
                    <mat-hint>
                        {{hint}}
                    </mat-hint>

                    <table>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>

                        <tbody>
                            <tr>
                                <td>
                                    Status
                                </td>
                                <td>
                                    <div>

                                        {{featureValues[featureSettings?.[item]?.state]}}
                                    </div>
                                </td>

                                <td>
                                    <ng-select  [appendTo]="'body'" formControlName="state" [clearable]="false">
                                        <ng-option [value]="'default'">Microsoft managed</ng-option>
                                        <ng-option [value]="'enabled'">Enabled</ng-option>
                                        <ng-option [value]="'disabled'">Disabled</ng-option>
                                    </ng-select>
                                </td>

                                <td>
                                    <sway-baseline-status
                                        [hasError]="form.get('featureSettings').get(item).get('state').value !== featureSettings?.[item]?.state"></sway-baseline-status>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    Include Target
                                </td>
                                <td>
                                    <div *ngIf="featureSettings?.[item]?.includeTarget?.id !=='all_users'">

                                        {{
                                        groups.get(featureSettings?.[item]?.includeTarget?.id)?.displayName
                                        || featureSettings?.[item]?.includeTarget?.id }}
                                    </div>


                                    <div *ngIf="featureSettings?.[item]?.includeTarget?.id ==='all_users'">


                                        All users
                                    </div>
                                </td>

                                <td formGroupName="includeTarget">
                                    <ng-select [appendTo]="'body'" formControlName="id" [multiple]="false"
                                        [clearable]="false" label="Select group or all users">
                                        <ng-option [value]="'all_users'">All users</ng-option>
                                        <ng-option *ngFor="let group of graphGroups"
                                            [value]="group.id">{{group.displayName}}</ng-option>
                                    </ng-select>
                                </td>

                                <td>
                                    <sway-baseline-status
                                        [hasError]="form.get('featureSettings').get(item).get('includeTarget.id').value !== featureSettings?.[item]?.includeTarget?.id"></sway-baseline-status>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    Exclude Target
                                </td>
                                <td>

                                    <ng-container
                                        *ngIf="featureSettings?.[item]?.excludeTarget?.id !=='00000000-0000-0000-0000-000000000000'">

                                        {{
                                        groups.get(featureSettings?.[item]?.excludeTarget?.id)?.displayName
                                        || featureSettings?.[item]?.excludeTarget?.id }}
                                    </ng-container>
                                </td>

                                <td formGroupName="excludeTarget">
                                    <ng-select [appendTo]="'body'" formControlName="id" [multiple]="false"
                                        label="Select group or all users">
                                        <ng-option *ngFor="let group of graphGroups"
                                            [value]="group.id">{{group.displayName}}</ng-option>
                                    </ng-select>
                                </td>


                                <td>
                                    <ng-container
                                        *ngIf="form.get('featureSettings').get(item).get('excludeTarget.id').value">

                                        <sway-baseline-status
                                            [hasError]="form.get('featureSettings').get(item).get('excludeTarget.id').value !== featureSettings?.[item]?.excludeTarget?.id"></sway-baseline-status>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="!form.get('featureSettings').get(item).get('excludeTarget.id').value">

                                        <sway-baseline-status
                                            [hasError]="featureSettings?.[item]?.excludeTarget?.id !=='00000000-0000-0000-0000-000000000000'"></sway-baseline-status>
                                    </ng-container>

                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</form>
